import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DeleteIcon } from '../../../../../assets/images/Delete.svg';
import { ReactComponent as Visa } from '../../../../../assets/images/paymentTypeMethods/VisaLogo.svg';
import { ReactComponent as VisaDark } from '../../../../../assets/images/paymentTypeMethods/VisaLogoDark.svg';
import { ReactComponent as MasterCard } from '../../../../../assets/images/paymentTypeMethods/MasterCardLogo.svg';
import { ReactComponent as DefaultCard } from '../../../../../assets/images/paymentTypeMethods/DefaultCard.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/images/InfoOutlined.svg';
import { CardSystem, ButtonClassNames } from '../../../../../models/Common';
import { IPaymentCard } from '../../../../../models/PaymentCard';
import { CustomTooltipInfo } from '../../../CustomTooltipInfo';
import { CustomMUIButton } from '../../../buttons/CustomMUIButton';
import { getCreditCardType } from '../../../../../utils';

interface InactiveTypeItemProps {
  theme: string;
  typeMethod: IPaymentCard;
  handleDelete: (cardId: string, cardNumber: string) => void;
}

interface ItemContentProps {
  content: string;
  logo: JSX.Element;
  id: number;
}

export const InactiveTypeItem: FC<InactiveTypeItemProps> = ({ theme, typeMethod, handleDelete }) => {
  const { t } = useTranslation();

  const getIconPaymentTypeLogo = (type: IPaymentCard, colorTheme: string): ItemContentProps => {
    switch (true) {
      case getCreditCardType(type.Card) === CardSystem.VISA: {
        return {
          logo: colorTheme === 'light' ? <Visa /> : <VisaDark />,
          content: type.Card,
          id: type.id,
        };
      }
      case getCreditCardType(type.Card) === CardSystem.MASTERCARD: {
        return {
          logo: <MasterCard />,
          content: type.Card,
          id: type.id,
        };
      }
      default: {
        return {
          logo: <DefaultCard />,
          content: type.Card,
          id: type.id,
        };
      }
    }
  };

  const content = getIconPaymentTypeLogo(typeMethod, theme);

  const remove = () => {
    handleDelete(`${content.id}`, content.content);
  };

  return (
    <div className="payment__type__container__content__payment-method__list__item inactive-card">
      <div className="item-name">
        <div className="item-name__logo">{content.logo}</div>
        <div className="item-name__content">
          <p>{content.content}</p>
        </div>
      </div>
      <div className="item-arrow">
        <CustomTooltipInfo
          tooltipText=""
          element={
            <>
              <div style={{ maxWidth: '250px' }}>{t('servicePayment.canceledSavedToken')}</div>
            </>
          }
        >
          <InfoIcon />
        </CustomTooltipInfo>
      </div>
      <div className="item-remove">
        <CustomMUIButton
          label={<DeleteIcon />}
          handleClick={remove}
          className={ButtonClassNames.IconGrayFulfilled}
          tooltipText={`${t('buttons.delete')}`}
        />
      </div>
    </div>
  );
};
